export default "__VITE_ASSET__DP57anPP__"